import * as React from 'react';
import { 
  DialogContent,
  IconButton,
  FormControl,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  Radio
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CDialog, CDialogTitle, CDialogActions, CButton, CTextField } from '../components/common/Modal';

export default function ChartModal(props) {
  const {open, type: defaultType, handleSave, handleClose} = props;
  const [type, setType] = React.useState(defaultType);

  const handleType = (e) => {
    setType(e.target.value)
  }
 
  return (
    <>
      <CDialog
        open={open}
        onClose={handleClose}
        maxWidth={"xs"}
        fullWidth
      >
        <CDialogTitle>Edit Chart</CDialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 6,
            top: 6,
            color: (theme) => theme.palette.grey[800],
          }}
        >
          <CloseIcon fontSize='small' />
        </IconButton>
        <DialogContent>
        <FormControl>
          <FormLabel id="chart-type-radio-buttons-group">Type</FormLabel>
          <RadioGroup
            aria-labelledby="chart-type-radio-buttons-group"
            name="chart-type-buttons-group"
            value={type}
            onChange={handleType}
          >
            <FormControlLabel value="bar" control={<Radio />} label="Bar" />
            <FormControlLabel value="line" control={<Radio />} label="Line" />
            <FormControlLabel value="area" control={<Radio />} label="Area" />
            <FormControlLabel value="pie" control={<Radio />} label="Pie" />
          </RadioGroup>
        </FormControl>
        </DialogContent>
        <CDialogActions>
          <CButton onClick={handleClose}>Cancel</CButton>
          <CButton onClick={() => handleSave(type)}>Ok</CButton>
        </CDialogActions>
      </CDialog>
    </>
  )
}